import { release_2023_2_1 } from "./release_2023_2_1/release_2023_2_1";
import { release_2023_2_0 } from "./release_2023_2_0/release_2023_2_0";
import { release_2024_1_0 } from "./release_2024_1_0/release_2024_1_0";
import { release_2024_2_0 } from "./release_2024_2_0/release_2024_2_0";
import { release_2025_1_0 } from "./release_2025_1_0/release_2025_1_0";
import { Release } from "shared-ts-release";
import { release_2025_2_0 } from "./release_2025_2_0/release_2025_2_0";
import { release_2026_1_0 } from "./release_2026_1_0/release_2026_1_0";

export const releases: Release[] = [
  release_2026_1_0,
  release_2025_2_0,
  release_2025_1_0,
  release_2024_2_0,
  release_2024_1_0,
  release_2023_2_1,
  release_2023_2_0,
];
